import CountdownTimer from './CountdownTimer.jsx'
import UserChip from './UserChip.jsx'
import { useAuth } from '../hooks/useAuth.js'

/**
 * Page header — title, subtitle, countdown, and edit-mode toggle.
 */
export default function Header() {
  const { authenticated, isDevMode, user } = useAuth()

  return (
    <div className="page-header">
      <div>
        <div className="page-title">Q2 2026 Goals</div>
        <div className="page-subtitle">Common Trust · 6 strategic pillars · Click any field to edit</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <CountdownTimer />
        {/* Production (CF Access) — show identity as read-only badge */}
        {authenticated && user && (
          <span
            title={`Signed in as ${user}`}
            style={{
              background: '#f3f4f6',
              border: '1px solid var(--border)',
              borderRadius: 99,
              padding: '5px 12px',
              fontSize: 11,
              fontWeight: 600,
              color: 'var(--text-secondary)',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: 16,
                height: 16,
                borderRadius: '50%',
                background: '#3b82f6',
                color: '#fff',
                fontSize: 9,
                fontWeight: 800,
                lineHeight: '16px',
                textAlign: 'center',
              }}
            >
              {user[0]}
            </span>
            {user}
          </span>
        )}
        {/* Dev mode (localhost, no CF Access) — manual picker */}
        {isDevMode && <UserChip />}
      </div>
    </div>
  )
}
